/**
 * Fetches all activity docs for a session, flattens urlUsage.entries across
 * all pings, and aggregates by full URL.
 *
 * Returns: [{ url, domain, title, totalSeconds }] sorted by totalSeconds desc
 */
export const fetchSessionUrlActivities = async (
  db,
  { teamId, userId, sessionId }
) => {
  const snapshot = await db
    .collection('teamDatabase')
    .doc(teamId)
    .collection('members')
    .doc(userId)
    .collection('sessions')
    .doc(sessionId)
    .collection('activities')
    .get();

  const urlMap = {};

  for (const doc of snapshot.docs) {
    const entries = doc.data()?.urlUsage?.entries;
    if (!Array.isArray(entries)) continue;
    for (const entry of entries) {
      if (!entry.url) continue;
      const existing = urlMap[entry.url];
      if (!existing) {
        urlMap[entry.url] = {
          url: entry.url,
          domain: entry.domain || '',
          title: entry.title || entry.url,
          totalSeconds: Number(entry.duration_seconds) || 0,
        };
      } else {
        existing.totalSeconds += Number(entry.duration_seconds) || 0;
        if (entry.title) existing.title = entry.title;
      }
    }
  }

  return Object.values(urlMap).sort((a, b) => b.totalSeconds - a.totalSeconds);
};
